// ============================================================
// DAMAGE, IN WORDS - what the log says when it may not count.
//
// Banding the wound readouts and leaving the log printing "7 damage"
// would be decoration: the players keep a tally and the bands mean
// nothing. But hiding the damage entirely costs them the sense that
// their own attacks are accomplishing something, which is most of what
// makes a fight readable.
//
// So the log keeps saying how bad it was, in the language a person at
// the table would use, scaled to what the blow was worth AGAINST THIS
// TARGET - the same wound is a graze on a dreadnought and mortal on a
// guardsman.
// ============================================================

/** Fraction of maximum wounds → what a person would call it. */
const BANDS: { atLeast: number; phrase: string }[] = [
  { atLeast: 0.45, phrase: 'a terrible wound' },
  { atLeast: 0.28, phrase: 'a grievous wound' },
  { atLeast: 0.15, phrase: 'a serious wound' },
  { atLeast: 0.06, phrase: 'a solid hit' },
  { atLeast: 0.0001, phrase: 'a glancing hit' },
];

/**
 * How bad a blow was, without saying how many.
 *
 * `max` is the TARGET's wound total, so the phrase is relative to what
 * the blow means for them rather than absolute.
 *
 * Zero is "the armour holds" rather than nothing at all: a hit that
 * connected and did nothing is information the players should have -
 * that is the popcorn the protagonist rules exist to fix, and hiding it
 * would hide whether the fix is working.
 */
export function damagePhrase(damage: number, max: number): string {
  if (damage <= 0) return 'the armour holds';
  if (!(max > 0)) return 'a hit';
  const fraction = damage / max;
  for (const band of BANDS) if (fraction >= band.atLeast) return band.phrase;
  return 'a glancing hit';
}
